import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Bs1CircleFill, Bs2CircleFill, Bs3CircleFill } from 'react-icons/bs';
import './Resellers.css';

function Resellers() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    // Agrega el asunto al formData
    const enhancedFormData = {
      ...formData,
      _subject: 'Solicitud de Registro de Usuario' // Asunto personalizado
    };

    // Enviar datos a FormSubmit
    fetch("https://formsubmit.co/ajax/pojobox.3d@gmail.com", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(enhancedFormData), // Cambiar aquí a enhancedFormData
    })
      .then(response => {
        if (response.ok) {
          // Mostrar mensaje de confirmación
          setIsSubmitted(true);
        } else {
          // Manejar errores aquí si es necesario
          console.error('Error al enviar el formulario');
        }
      })
      .catch(error => {
        console.error('Error de red:', error);
      })
      .finally(() => {

        setLoading(false);
      });

    // Restaurar el formulario luego de 10 segundos
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: ''
      });
    }, 10000);

  };

  return (
    <div className="resellers-container">
      <h2>¿Quieres Ser Revendedor?</h2>
      <div className="resellers-description">
        <div className='left-section'>
          <p className='justify'>¡Conviértete en revendedor de productos únicos y personalizados! 🎁✨</p>
          <p className='justify bold'>Te ofrecemos:</p>
          <ul>
            <li><span className='bold'>Regalos únicos y memorables:</span> Ideales para ocasiones especiales, souvenirs, o simplemente para consentirte.</li>
            <li><span className='bold'>Productos de impresión 3D personalizados:</span> Desde figuras decorativas hasta artículos funcionales, hechos a medida.</li>
            <li><span className='bold'>Precios exclusivos para revendedores:</span> Aumenta tus ganancias ofreciendo artículos originales y creativos.</li>
            <li><span className='bold'>Soporte integral:</span> Te acompañamos en cada paso para que tu negocio destaque.</li>
          </ul>
          <p className='justify'>¿Listo para llevar ideas increíbles a tus clientes? Empieza hoy y sé parte de una comunidad innovadora y apasionada por lo único. 🚀</p>
        </div>
        <div className='image-resellers right-section'>
          <img src={require("../assets/resellers/unique-products.png")} alt="unique-products" />
        </div>
        {/* Botón Ir a Tienda */}
      </div>

      <div className="shop-button-container">
        <Link to="/products"> Ir a Tienda</Link>
      </div>

      <div className="how-it-works">
        <h2>¿Cómo funciona?</h2>
        <ol>
          <li>
            <div className='list-steps'>
              <div className='left-section'><span className='bold'>Llena el formulario:</span> Proporciona tus datos básicos para iniciar el proceso.</div>
              <div className='image-resellers right-section'>
                <img src={require("../assets/resellers/form.png")} alt="form" />
                <div className="step-number">
                  <Bs1CircleFill className="icon-step" />
                </div>
              </div>
            </div>
          </li>
          <li>
            <div className='list-steps'>
              <div className='right-section'><span className='bold'>Revisión y creación de usuario:</span> Nuestro administrador revisará tu solicitud y creará un usuario exclusivo para ti.</div>
              <div className='image-resellers left-section'>
                <img src={require("../assets/resellers/administrator.png")} alt="administrator" />
                <div className="step-number">
                  <Bs2CircleFill className="icon-step" />
                </div>
              </div>
            </div>
          </li>
          <li>
            <div className='list-steps'>
              <div className='left-section'><span>Acceso exclusivo:</span> Una vez creado tu usuario, podrás iniciar sesión y acceder a precios especiales con descuentos exclusivos para revendedores.</div>
              <div className='image-resellers right-section'>
                <img src={require("../assets/resellers/login.png")} alt="login" />
                <div className="step-number">
                  <Bs3CircleFill className="icon-step" />
                </div>
              </div>
            </div>
          </li>
        </ol>
        <p>¡Es simple, rápido y te permitirá disfrutar de grandes beneficios en productos personalizados!</p>
      </div>

      <div className="info-cards-container">
        <h2 className="info-cards-title">Opciones de Venta</h2>
        {/* Tarjetas de Información */}
        <div className="info-cards">
          <div className="info-card">
            <h3>Venta Minorista - Impresiones 3D</h3>
            <ul>
              <li><span className='bold'>Mínimo del pedido:</span> $15.000</li>
              <li><span className='bold'>Descuentos:</span> 30% OFF en modelos personalizados y objetos decorativos impresos en 3D</li>
              <li><span className='bold'>Soporte:</span> Acompañamiento completo en el diseño y personalización de los productos</li>
              <li><span className='bold'>Modelos disponibles:</span> Llaveros, adornos, soportes y más, ¡hechos a medida!</li>
            </ul>
          </div>

          <div className="info-card">
            <h3>Venta Mayorista - Impresiones 3D</h3>
            <ul>
              <li><span className='bold'>Mínimo del pedido:</span> $50.000</li>
              <li><span className='bold'>Descuentos:</span> 40% OFF en pedidos grandes de productos 3D</li>
              <li><span className='bold'>Incluye:</span> Asesoramiento en la personalización de productos</li>
              <li><span className='bold'>Soporte:</span> Soporte continuo para ajustar diseños según necesidades de tus clientes</li>
            </ul>
          </div>
        </div>
      </div>
      {/* Sección Quiero Vender */}
      <div className="sell-section">
        {loading && ( // Mostrar el loader si está activo
          <div className="loader-overlay">
            <div className="loader"></div>
          </div>
        )}
        <h2 className="sell-title">¿Quieres Vender Nuestros Productos?</h2>
        <p className="justify">Llena el siguiente formulario para empezar a vender nuestros productos exclusivos de impresión 3D y acceder a una amplia gama de opciones únicas.</p>

        <div className="contact-form-container">
          {isSubmitted ? (
            <div className="confirmation-message">
              <h2>Gracias por tu mensaje</h2>
              <p>Nos pondremos en contacto contigo pronto.</p>
            </div>
          ) : (
            <form className='sell-form' onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Nombre Completo:</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Correo Electrónico:</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Teléfono:</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">¿Por qué quieres vender nuestros productos?</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>

              <button type="submit" className="submit-button">Enviar</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default Resellers;
